(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/category-title.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/category-title.js');
"use strict";

const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Icon = svs.ui.ReactIcon;
const CategoryTitle = _ref => {
  let category = _ref.category,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const CATEGORY = svs.eInstant.constants.ROUTES.CATEGORY;
  const title = category.title,
    urlPath = category.urlPath,
    icon = category.icon,
    _category$favorites = category.favorites,
    favorites = _category$favorites === void 0 ? false : _category$favorites;
  const url = favorites ? urlPath : "".concat(CATEGORY.replace(':categoryId', urlPath));
  const history = useHistory();
  if (urlPath) {
    return React.createElement("a", {
      "aria-label": "G\xE5 till ".concat(title),
      href: url,
      onClick: e => {
        e.preventDefault();
        history.push(url);
      }
    }, React.createElement("div", {
      className: "u-flex u-flex-align-items-center f-body ".concat(className)
    }, React.createElement(Icon, {
      color: "fc-fler-lotter-new-700",
      icon: icon,
      size: 500
    }), React.createElement("h2", {
      className: "h2 tickets-einstant-categories-title fc-fler-lotter-new-700 margin-0 padding-h-1"
    }, title), React.createElement(Icon, {
      color: "fc-fler-lotter-new-700",
      icon: "arrow-right",
      size: 500
    })));
  }
  return React.createElement("div", {
    className: "u-flex u-flex-align-items-center f-body ".concat(className)
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700",
    icon: icon,
    size: 500
  }), React.createElement("h2", {
    className: "h2 tickets-einstant-categories-title fc-fler-lotter-new-700 margin-0 padding-h-1"
  }, title));
};
setGlobal('svs.eInstant.shared.components.CategoryTitle', CategoryTitle);

 })(window);